import { Dashboard } from "@/model/data/dashboard/Dashboard";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../../ApiGenericResponse";

export class FetchDashboardResData extends ApiGenericResponse {
    dashboard: Dashboard = null;
    breakpoint: string;

    constructor(response: AxiosResponse, breakpoint: string) {
        super(response);
        if (response.data && response.data.Payload) {
            var dashboard = new Dashboard();
            dashboard.fillFromJson(response.data.Payload, breakpoint);
            this.dashboard = dashboard;
        }
    }
}
